export function isStringEqualTo(string1, string2) {
    if (string1?.toLowerCase() === string2?.toLowerCase()) {
        return true
    }
    return false
}


export const alphanumericOnly = (string) => {
    let filteredString = string.replace(/[^a-z0-9]/gi, '');
    return filteredString
}

export const alphanumericWithSpaceOnly = (string) => {
    let filteredString = string.replace(/[^a-z0-9, ]/gi, '');
    return filteredString
}

export const alphabetsOnly = (string) => {
    let filteredString = string.replace(/[^a-z, ]/gi, '');
    return filteredString
}

export function isEmail(email) {
    let result = email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)
    if (result?.[0]) {
        return true
    }
    return false
}

export function isPhoneNumber(value) {
    const phonePattern = /^[0-9]{10}$/; // Regular expression to match a 10-digit phone number
    if(value.length===0)
    {
        return true
    }
   
    return phonePattern.test(value);
  }

export function textWithFirstCharUpper(string) {
    if(string===undefined || string===null || string==="" )
    {
        return string
    }
    return string.charAt(0).toUpperCase() + string.slice(1)

}


export function insertHashupFront(hexColor)
{
   return hexColor.includes("#")? hexColor : "#"+hexColor
}
export function textWithOnlyUpper (string) {
    if (string === undefined || string === null || string === '') {
      return string
    }
    return string.toUpperCase()
  }